// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type TargetFolderId from '../contract/TargetFolderId';

export default function targetFolderId(data: TargetFolderId): TargetFolderId {
    const result: TargetFolderId = {
        __type: 'TargetFolderId:#Exchange',
        ...data,
    };

    return result;
}
